import React, { useCallback, useMemo } from "react";

// Navigate
import Box from "@mui/material/Box";
import { useNavigate, useParams } from "react-router-dom";

// Components
import PromotionCalendarDialog from "@/components/Dialog/promotionCalendarDialog";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { Typography } from "@mui/material";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";

// Fetch
import { getPublicHolidays } from "@/fetch/fetchRoster";

import { getAll, remove, upsert } from "@/fetch/Pharmagood/fetchCalendar";
import { useCurrentAction } from "@/hooks/user";
import _ from "lodash";
import "react-big-calendar/lib/css/react-big-calendar.css";
const PharmaGoodCalendarPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();
  const [isDialogOpen, setDialogOpen] = React.useState(false);
  const [events, setEvents] = React.useState([]);
  const [event, setEvent] = React.useState({ allow_redeem: false });
  const [holidays, setHolidays] = React.useState({});
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  // Navigate
  const navigate = useNavigate();
  const localizer = momentLocalizer(moment);
  const params = useParams();
  const eventPropGetter = useCallback((event, start, end, isSelected) => {
    return {
      style: {
        backgroundColor: event.backgroundColor,
      },
    };
  }, []);
  const { defaultDate } = useMemo(
    () => ({
      defaultDate: moment(params.date),
    }),
    [params.date],
  );
  const handleSelectSlot = (props) => {
    const event = _.find(
      events,
      (e) =>
        moment(e.date).format("YYYY-MM-DD") ===
        moment(props.start).format("YYYY-MM-DD"),
    );
    if (event) {
      setEvent({ ...event, isNew: false });
    } else {
      setEvent({
        title: "",
        isNew: true,
        allow_redeem: false,
        date: moment(props.start),
      });
    }
    setDialogOpen(true);
  };

  const handleSelectEvent = useCallback((event) => {
    setDialogOpen(true);
    setEvent(event);
  }, []);
  const handleDelete = async () => {
    try {
      await remove(moment(upsert.date).format("YYYY-MM-DD"));
      setSnackSeverity("success");
      setSnackMessage("刪除成功");
    } catch (err) {
      setSnackSeverity("error");
      setSnackMessage(`刪除失敗\n${err.message}`);
    } finally {
      await fetchAll();
      setSnackOpen(true);
      setDialogOpen(false);
    }
  };
  const handleSubmit = async () => {
    try {
      await upsert(moment(upsert.date).format("YYYY-MM-DD"), event);
      setSnackSeverity("success");
      setSnackMessage("更新成功");
    } catch (err) {
      setSnackSeverity("error");
      setSnackMessage(`更新失敗\n${err.message}`);
    } finally {
      await fetchAll();
      setSnackOpen(true);
      setDialogOpen(false);
    }
  };

  const handleOnChange = (value, key) => {
    setEvent((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };
  // Fetch
  const fetchAll = async () => {
    const data = await getAll();
    const formattedEvent = [];
    _.forEach(data, (d) => {
      formattedEvent.push({
        ...d,
        start: moment(d.date),
        end: moment(d.date),
        date: moment(d.date),
      });
    });
    const { data: holidaysData } = await getPublicHolidays();
    setHolidays(holidaysData);
    setEvents(formattedEvent);
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const DateCellContent = (props) => {
    const { date } = props;
    const dayOfWeek = date.getDay();
    return (
      <Box
        component="span"
        style={{
          color:
            dayOfWeek === 0 || holidays[moment(date).format("YYYY-MM-DD")]
              ? "red"
              : "",
        }}
      >
        <Typography>{props.label}</Typography>

        {holidays[moment(date).format("YYYY-MM-DD")] && (
          <Typography>{holidays[moment(date).format("YYYY-MM-DD")]}</Typography>
        )}
      </Box>
    );
  };
  return (
    <Layout
      header="RosterPage"
      selectedIndex={22}
      open={open}
      setOpen={setOpen}
      snackClose={() => setSnackOpen(false)}
      snackSeverity={snackSeverity}
      snackMessage={snackMessage}
      snackOpen={snackOpen}
    >
      <Title history={() => navigate(-1)} title="特別日子設定" />

      <PromotionCalendarDialog
        open={isDialogOpen}
        submitMessage={"提交"}
        deleteMessage={"刪除"}
        actions={actions}
        event={event}
        events={events}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        handleOnChange={handleOnChange}
        onCancel={() => setDialogOpen(!isDialogOpen)}
      ></PromotionCalendarDialog>
      <Calendar
        localizer={localizer}
        eventPropGetter={eventPropGetter}
        events={events}
        defaultDate={defaultDate}
        startAccessor="start"
        endAccessor="end"
        onSelectEvent={handleSelectEvent}
        onSelectSlot={handleSelectSlot}
        style={{ height: 650 }}
        views={["month"]}
        showMultiDayTimes={true}
        selectable
        messages={{
          previous: "上個月",
          next: "下個月",
          today: "今月",
        }}
        components={{
          month: {
            dateHeader: DateCellContent,
          },
        }}
      />
    </Layout>
  );
};

export default PharmaGoodCalendarPage;
